import omit from 'lodash/omit';
import get from 'lodash/get';
import keys from 'lodash/keys';
import flow from 'lodash/flow';
import { omitKeys } from './constants';

const filterKeys = item => omit(item, omitKeys);
const getFilteredKeys = item => flow([filterKeys, keys])(item);

export const mapTableHeaderColumns = (tableData) => {
  const getFirstItem = items => get(items, '[0]', {});
  return flow([getFirstItem, getFilteredKeys])(tableData);
};

export const mapTableColumns = item => getFilteredKeys(item);

